export const AmazonBuyShippingService = Object.freeze({
  UspsPriorityMail: '2709',
  FedexGround: '2740',
  FedexHomeDelivery: '2741',
  Fedex2Day: '2743',
  FedexStandardOvernight: '2746',
  FedexSecondDayOneRate: '2751',
  UpsGround: '2760',
  Ups3DaySelect: '2762',
  Ups2ndDayAir: '2763',
  UpsNextDayAirSaver: '2765',
  UpsNextDayAir: '2766',
  UspsGroundAdvantageLessThan1Lb: '8916',
  UspsGroundAdvantage1lbTo70lb: '8917',
  UspsGroundAdvantageCubic: '8918',
});
